module.exports = __webpack_public_path__ + "static/media/GTBSLong2w522@2x.57544831.webp";